<script setup lang="ts">
/*function openCrisp() {
  const crisp = useScriptCrisp({
    id: useRuntimeConfig().public.crispWebsiteId,
  })
  crisp.do('chat:hide')
  crisp.on('message:received', () => crisp.do('chat:show'))
  crisp.on('chat:opened', () => crisp.do('chat:show'))
  crisp.on('chat:closed', () => crisp.do('chat:hide'))
  crisp.do('chat:open')
}*/
const profile = useState('profile')
</script>

<template>
  <UModal :dismissible="false" title="Comment pouvons-nous vous aider ?">
    <template #body>
      <div class="space-y-5">
        <UPageCard
            v-if="profile.groups.length || profile.platforms.length"
            title="Tout savoir sur l'Espace Asso"
            description="Prise en main du service, bonnes pratiques pour vous et vos antennes, ressources supplémentaires, appuyez vous sur notre expertise humaine et numérique pour optimiser votre utilisation du service"
            icon="i-ph-lightbulb-duotone"
            to="https://benevolt.notion.site/Pour-les-r-f-rents-au-si-ge-des-r-seaux-191c0556058180dcabb4c301c9718d3e"
            target="_blank"
        />
        <UPageCard
          title="Visiter notre centre d'aide"
          description="La réponse à votre question est peut être déjà disponible ici"
          icon="i-ph-lifebuoy-duotone"
          to="https://aide.benevolt.fr/fr/category/espace-asso-7cggbc/"
          target="_blank"
        />
        <UPageCard
          title="Contacter notre support"
          description="Contactez-nous sans hésiter ! Notre équipe est à votre disposition et vous répondra dans les plus brefs délais. Le support est disponible du lundi au vendredi, de 9h30 à 17h30."
          icon="i-ph-chat-teardrop-dots-duotone"
          to="https://go.crisp.chat/chat/embed/?website_id=20cff4bb-2cf2-4337-aaf1-4f23812a7a49"
          target="_blank"
        />
      </div>
    </template>
  </UModal>
</template>